import Keycloak, { KeycloakConfig, KeycloakInitOptions } from 'keycloak-js'

const keycloakConfig: KeycloakConfig = {
    url: process.env.REACT_APP_KEYCLOAK_URL!,
    realm: process.env.REACT_APP_KEYCLOAK_REALM!,
    clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID!,
}

const keycloak = new (Keycloak as any)(keycloakConfig)

const initOptions: KeycloakInitOptions = {
    onLoad: 'login-required',
    checkLoginIframe: false,
    pkceMethod: 'S256',
    enableLogging: true,
    responseMode: 'query',
    useNonce: false,
}

export { keycloak, initOptions }
